// extracted by mini-css-extract-plugin
export default {"oos":"StockStatus_oos__tqVqK","ins":"StockStatus_ins__JveZD","uks":"StockStatus_uks__bFu5y","bts":"StockStatus_bts__ywgii"};